import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';
import {getLoginSubrootUrl, getSubRoot, getUrl} from '../utils.jsx';
// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      // Logged in from /login (no subroot): to the home of the organization of the login. Its
      // routes are only built on a fresh page load (they're derived from window.location)
      if (getSubRoot(location.pathname) === '') {
        const homeUrl = getLoginSubrootUrl(APP_DEFAULT_PATH);
        if (homeUrl) window.location.replace(homeUrl);
        return;
      }

      const target = location?.state?.from || APP_DEFAULT_PATH;
      const redirectUrl = getUrl(location.pathname, target);

      navigate(redirectUrl, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
